import axiosInstance from './axiosInstance';

export interface UserPointsListParams {
  userId: string;
  pointsType: number; // -1:全部积分;1:获得积分;0:消耗积分
  currentPage: number;
  pageSize: number;
}

export interface UserPointsRecordDTO {
  id: string;
  userId: string;
  pointsType: number; // 0 扣减；1 增加
  points: number;
  pointsSense: string;
  source: string;
  availablePoints: number;
  createTime: string;
  updateUser: string;
}

export interface UserPointsSummaryDTO {
  userId: string;
  name: string;
  headImageUrl: string;
  availablePoints: number;
  usedPoints: number;
  sumPoints: number;
}

export interface UserPointsListResponse {
  total: number;
  currentPage: number;
  pageSize: number;
  records: UserPointsRecordDTO[];
  summary: UserPointsSummaryDTO;
}

/**
 * 获取用户积分明细列表
 */
export const getUserPointsList = async (
  params: UserPointsListParams
): Promise<{
  data: UserPointsListResponse;
  status: number;
  success: boolean;
  message: string;
}> => {
  const res = await axiosInstance.get<{
    data: UserPointsListResponse;
    status: number;
    success: boolean;
    message: string;
  }>(`${SUPP_ADMIN_BASE_URL}/supp-management/review/user/points/list`, {
    params,
  });
  return res.data;
};

export interface UpdateUserPointsParams {
  points: number;
  operatorType: 1 | 0; // 1:发放积分；0:减扣积分
  userId: string;
}

export const updateUserPoints = async (params: UpdateUserPointsParams) => {
  return axiosInstance.post<{ status: number; message: string }>(
    `${SUPP_ADMIN_BASE_URL}/supp-management/review/user/points/update`,
    params
  );
};

// 管理端 - 用户积分明细
export async function getUserPointsRecordsManagement(params: {
  pointsType: number;
  currentPage: number;
  pageSize: number;
}) {
  const res = await axiosInstance.get(
    `${SUPP_ADMIN_BASE_URL}/supp-management/user/points/records`,
    {
      params,
    }
  );
  return res.data;
}

// 管理端 - 用户积分调整
export async function adjustUserPoints(data: {
  userId: string;
  pointsType: number;
  points: number;
}) {
  const res = await axiosInstance.post(
    `${SUPP_ADMIN_BASE_URL}/supp-management/user/points/adjust`,
    data
  );
  return res.data;
}

// App端 - 用户积分明细
export async function getUserPointsListApp(params: {
  currentPage: number;
  pageSize: number;
  pointsOpType: number;
}) {
  const res = await axiosInstance.get(
    `${SUPP_ADMIN_BASE_URL}/supp-management/shopping-mall/api/userPoints/v1/list`,
    {
      params,
    }
  );
  return res.data;
}

// App端 - 积分信息
export async function getUserPointsInfo() {
  const res = await axiosInstance.get(
    `${SUPP_ADMIN_BASE_URL}/shopping-mall/api/userPoints/v1/points/info`
  );
  return res.data;
}

export interface UserPointsInfoResponse {
  headImageUrl: string;
  name: string;
  userNumber: string;
  totalPoints: string;
  usagePoints: string;
  remainingPoints: string;
}

// 获取用户积分信息
export const getUserPointsInfoNew = async (userId: string) => {
  const res = await axiosInstance.get<{
    status: number;
    success: boolean;
    message: string;
    data: UserPointsInfoResponse;
  }>(`${SUPP_ADMIN_BASE_URL}/supp-management/review/user/points/info`, {
    params: { userId },
  });
  return res.data;
};
